import styled from "styled-components";

let titleBarHeight = 90;
let bottomBarHeight = 50;

export const DeviceDetailsScreenWrapper = styled.div`
    width: 100%;
    height: 100%;
    background-image: url(/static/images/big-screen/qyc/device-details-background.png);
    background-size: 100% 100%; 
    background-repeat: no-repeat;
    color: #FFFFFF;
    letter-spacing: 2px;
    background-position: center;
    background-size: cover;
`;

export const ScreenBorderTop = styled.div`
    position: absolute;
    background-image: url(/static/images/big-screen/qyc/device-details-border.png);
    background-size: 60% 100%; 
    background-repeat: no-repeat;
    background-position: center;
    top: 0px;
    left: 0px;
    width: 100%;
   // z-index: 200;
    height: ${titleBarHeight}px;              
`;

export const ScreenBorderBottom = styled.div`
    position: absolute;
    background-image: url(/static/images/big-screen/qyc/device-details-bottom-background.png);
    background-size: 100% 100%; 
    background-repeat: no-repeat;
    bottom: 0px;
    left: 0px;
    width: 100%;
   // z-index: 300;
    height: ${bottomBarHeight}px;              
`;

export const ScreenBorderLeft = styled.div`
    position: absolute;
    background-image: url(/static/images/big-screen/qyc/device-details-border.png);
    background-size: 100% 100%; 
    background-repeat: no-repeat;
    top: 2px;
    left: 2px;
    bottom: 0px;
    width: 550px;
 //   z-index: 200;
`;

export const ScreenBorderRight = styled.div`
    position: absolute;
    background-image: url(/static/images/big-screen/qyc/device-details-border.png);
    background-size: 100% 100%; 
    background-repeat: no-repeat;
    top: 2px;
    bottom: 0px;
    right: 2px;
    width: 550px;
   // z-index: 200;
    transform: scaleX(-1);             
`;

export const DeviceDetailsScreenInnerWrapper = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    min-height: 850px;
    color: #FFFFFF;
    letter-spacing: 2px;
`;

export const ScreenTitleBar = styled.div`
    position: absolute;
    z-index: 200;
    left: 0%;
    top: 0%;
    width: 100%;
    height: ${titleBarHeight}px;
    padding: 30px 10px 10px 10px;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
`;

export const DeviceDetailsContent = styled.div`
    display: grid;
    position: absolute;
    top: calc(${titleBarHeight}px);
    width: 100%;
    height: calc(100% - ${titleBarHeight}px - ${bottomBarHeight}px);
    padding: 10px;
    grid-template-columns: 2fr 5fr 2fr;
    //grid-gap: 10px;
    align-items: stretch;
    justify-items: stretch;
    box-sizing: border-box;
`;

export const DeviceImageInformationandAlarmWrappers = styled.div`
    grid-column: 2 / 3;
    grid-row: 1 / 2; 
    display: grid;
    grid-template-rows: 1fr 5fr 1fr;
`;


export const ChartLeftWrappers = styled.div`
    grid-column: 1 / 2;
    grid-row: 1 / 2; 
`;

export const ChartRightWrappers = styled.div`
    grid-column: 3 / 4;
    grid-row: 1 / 2; 
`;

export const DeviceInformationWrappers = styled.div`
    grid-column: 1 / 2;
    grid-row: 1 / 2; 
    margin: 20px 10px;
`;

export const DeviceAlarmWrappers = styled.div`
    grid-column: 1 / 2;
    grid-row: 3 / 4; 
    margin: 10px 15px;
`;


export const DeviceImageandDetailsWrapper = styled.div`
    grid-row: 2 / 3;
    background-image: url(/static/images/big-screen/qyc/pooduct-frame.png);
    background-size: 140% 165%; 
    background-repeat: no-repeat;
    background-position: center;
    display: grid;
    grid-template-columns: 2fr 3fr 2fr;
    grid-template-rows: 2fr 2fr 3fr 3fr 2fr 2fr;
`;


export const DeviceImageWrapper = styled.div`
    grid-column: 2 / 3;
    grid-row: 3 / 5;
    background-image: url(/static/images/big-screen/qyc/qyc.png);
    background-size: 190% 170%; 
    background-repeat: no-repeat;
    background-position: center;
`;    

export const DetailsDetailsAndMapWrapper = styled.div`
   // z-index: 100;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: stretch;
`;

export const DeviceDetailsWrapper = styled.div`
    width: 100%;
    flex: 0 0 auto;
    box-sizing: border-box;
`;

export const DeviceTrackWrapper = styled.div`
    width: 100%;
    flex: 1 1 auto;
    box-sizing: border-box;
`;

export const DeviceModel3DAndHealthWrapper = styled.div`
    grid-column: 2 / 4;
    grid-row: 1 / 2;
    display: grid;
    grid-template-columns: 2fr 1fr;
    grid-template-rows: 1fr;
    grid-gap: 20px;
    align-items: stretch;
`;

export const DeviceModel3DWrapper = styled.div`
    z-index: 100;
    overflow: hidden;
`;

export const DeviceHealthWrapper = styled.div`
    z-index: 100;
    box-sizing: border-box;
`;

export const DeviceRealtimeMetricsWrapper = styled.div`
    grid-column: 1 / 2;
    grid-row: 2 / 3;
    z-index: 100;
    box-sizing: border-box;
`;

export const DeviceMetricsWrapper = styled.div`
    grid-column: 2 / 4;
    grid-row: 2 / 3;
    z-index: 100;
    box-sizing: border-box;
`;
